<div class="flex min-w-0 flex-1 flex-col">
  <!-- Slot for things like breadcrumbs -->
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [hideSearch]="true"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <core-token-vaults-data-table-filter
          [dto]="appliedFilter()"
          [filters]="filters()"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold text-primary"
            >
              {{ column.label }}
            </th>
            @switch (column.key) {
              @case ('context') {
                <td mat-cell *matCellDef="let tokenVault">
                  @if (tokenVault.context?.user) {
                    <button
                      [matTooltip]="'Utilisateur'"
                      [routerLink]="['/users', tokenVault.context.user._id]"
                      mat-button
                      class="link flex flex-row items-center"
                    >
                      <aura-avatar
                        [label]="$safeNavigationMigration(tokenVault.context.user.identity?.firstName)"
                        [srcImage]="$safeNavigationMigration(tokenVault.context.user.identity.avatar?.url)"
                        [size]="'xs'"
                      />

                      <div class="ml-2">
                        {{
                          $safeNavigationMigration(tokenVault.context.user.identity?.firstName) | titlecase
                        }}
                        {{ $safeNavigationMigration(tokenVault.context.user.identity?.lastName) | titlecase }}
                      </div>
                    </button>
                  } @else if (tokenVault.context?.userRegistration) {
                    <button
                      [matTooltip]="'Inscription'"
                      [routerLink]="['/user-registrations', tokenVault.context.userRegistration._id]"
                      mat-button
                      class="link flex flex-row items-center text-gray-10"
                    >
                      {{
                        $safeNavigationMigration(tokenVault.context.userRegistration.identity?.firstName)
                          | titlecase
                      }}
                      {{
                        $safeNavigationMigration(tokenVault.context.userRegistration.identity?.lastName)
                          | titlecase
                      }}
                    </button>
                  } @else if (tokenVault.context?.betaRegistration) {
                    <button
                      [matTooltip]="'Inscription Bêta'"
                      [routerLink]="['/beta-registrations', tokenVault.context.betaRegistration._id]"
                      mat-button
                      class="link flex flex-row items-center text-gray-10"
                    >
                      {{
                        $safeNavigationMigration(tokenVault.context.betaRegistration?.firstName) | titlecase
                      }}
                      {{
                        $safeNavigationMigration(tokenVault.context.betaRegistration?.lastName) | titlecase
                      }}
                    </button>
                  }
                </td>
              }
              @case ('action') {
                <td mat-cell *matCellDef="let tokenVault">
                  <span class="font-medium text-neutral-12">
                    {{ tokenVault.action | tokenVaultActionDisplay }}
                  </span>
                </td>
              }
              @case ('verification') {
                <td mat-cell *matCellDef="let tokenVault">
                  @if (tokenVault.verification === 'email') {
                    <span
                      class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-sky-2 text-sky-11 border border-sky-4"
                    >
                      <mat-icon class="!w-3.5 !h-3.5 !text-sm">mail</mat-icon>
                      Email
                    </span>
                  } @else if (tokenVault.verification === 'sms') {
                    <span
                      class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-violet-2 text-violet-11 border border-violet-4"
                    >
                      <mat-icon class="!w-3.5 !h-3.5 !text-sm">sms</mat-icon>
                      SMS
                    </span>
                  } @else {
                    <span>{{ tokenVault.verification }}</span>
                  }
                </td>
              }
              @case ('token') {
                <td mat-cell *matCellDef="let tokenVault">
                  <code
                    [matTooltip]="tokenVault.token"
                    class="px-2 py-0.5 bg-neutral-2 border border-neutral-4 rounded text-xs font-mono text-neutral-11 cursor-default select-all"
                  >
                    {{
                      tokenVault.token.length > 16 ? tokenVault.token.slice(0, 14) + '...' : tokenVault.token
                    }}
                  </code>
                </td>
              }
              @case ('status') {
                <td mat-cell *matCellDef="let tokenVault">
                  @switch (tokenVault.status) {
                    @case ('open') {
                      <span
                        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-jade-2 text-jade-11 border border-jade-4"
                      >
                        <mat-icon class="!w-3.5 !h-3.5 !text-sm">lock_open</mat-icon>
                        Ouvert
                      </span>
                    }
                    @case ('used') {
                      <span
                        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-blue-2 text-blue-11 border border-blue-4"
                      >
                        <mat-icon class="!w-3.5 !h-3.5 !text-sm">check_circle</mat-icon>
                        Utilisé
                      </span>
                    }
                    @case ('expired') {
                      <span
                        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-amber-2 text-amber-11 border border-amber-4"
                      >
                        <mat-icon class="!w-3.5 !h-3.5 !text-sm">timer_off</mat-icon>
                        Expiré
                      </span>
                    }
                    @case ('canceled') {
                      <span
                        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-ruby-2 text-ruby-11 border border-ruby-4"
                      >
                        <mat-icon class="!w-3.5 !h-3.5 !text-sm">cancel</mat-icon>
                        Annulé
                      </span>
                    }
                    @default {
                      <span>{{ tokenVault.status | tokenVaultStatusDisplay }}</span>
                    }
                  }
                </td>
              }
              @case ('expireDate') {
                <td mat-cell *matCellDef="let tokenVault">
                  <span class="text-xs text-neutral-11">
                    {{ tokenVault.expireDate | luxonDate: 'dd/LL/yyyy HH:mm' }}
                  </span>
                </td>
              }
              @case ('usedDate') {
                <td mat-cell *matCellDef="let tokenVault">
                  <span class="text-xs text-neutral-11">
                    {{ tokenVault.usedDate ? (tokenVault.usedDate | luxonDate: 'dd/LL/yyyy HH:mm') : '-' }}
                  </span>
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let tokenVault">
                  <span class="text-xs text-neutral-10">
                    {{ tokenVault.createdAt | luxonDate: 'humanize' }}
                  </span>
                </td>
              }
              @case ('updatedAt') {
                <td mat-cell *matCellDef="let tokenVault">
                  <span class="text-xs text-neutral-10">
                    {{ tokenVault.updatedAt | luxonDate: 'humanize' }}
                  </span>
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let tokenVault">
                  {{ tokenVault[column.key] }}
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
